// this file is automatically generated by git.version.ts script
/* tslint:disable max-line-length */
export const versions = {date: 1580154571855, version: '1.2.0.7', revision: '9f922eb179ed2cf57fa38d669ef8d9b8ad6008f1', branch: 'release-6.0', tag: '1.0.0.6'};
